import { ReportProfileResource } from '../profile/report-profile-resource';

export class ReportProfileLoadedModel {
  adminObjectId: string;
  resources: ReportProfileResource[];
}
